import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { VeteranOwned } from './components/VeteranOwned';
import { HowItWorks } from './components/HowItWorks';
import { ServiceArea } from './components/ServiceArea';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background text-foreground font-sans selection:bg-primary selection:text-primary-foreground" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <VeteranOwned data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <ServiceArea data-id="element-7" />
        <FAQ data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}